import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

// Native port of the legacy deleteAssessmentCredentialModal
// (src/app/public/app/partials/missioncontrol/company/deleteAssessmentCredentialModal) -
// opened from company-page.component.js's openDeleteAssessmentCredentialsModal
// (component: 'deleteAssessmentCredentialModal'). The modal body embeds the
// already-native <app-delete-assessment-credential> component (ported earlier
// under assessments-management/) unchanged - this wrapper only replaces the
// legacy $uibModal chrome around it with BsModalService.
@Component({
  selector: 'app-company-page-delete-assessment-credential-modal',
  templateUrl: './company-page-delete-assessment-credential-modal.component.html'
})
export class CompanyPageDeleteAssessmentCredentialModalComponent implements OnInit {

  public onClose: Subject<any>;

  modalData: any = {};

  context: string;
  companyId: any;
  buId: any;
  testOwnerEmail: any;
  assessmentId: any;
  isDeleteCredential: boolean;
  title: string;

  callbackObject: any = { callbackType: 'cancel', entity: {} };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.context = this.modalData.context;
    this.companyId = this.modalData.companyId;
    this.buId = this.modalData.buId;
    this.testOwnerEmail = this.modalData.testOwnerEmail;
    this.assessmentId = this.modalData.assessmentId;
    this.isDeleteCredential = this.modalData.isDeleteCredential;
    this.title = this.isDeleteCredential ? 'Assessment Credential Deletion' : 'Remove Assessment';
  }

  delete() {
    this.callbackObject = { callbackType: 'delete', entity: {} };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  closeModal() {
    this.callbackObject = { callbackType: 'cancel', entity: {} };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }
}
